import api from '../api/client';

const create = async (appId, payload = {}) => {
    const res = await api.post('/api/api-keys/create', payload, { params: { app_id: appId } });
    return res?.data;
};

const list = async (appId) => {
    const res = await api.get('/api/api-keys/list', { params: { app_id: appId } });
    return res?.data?.data;
};

const rotate = async (apiKeyId) => {
    const res = await api.post('/api/api-keys/rotate', { api_key_id: apiKeyId });
    return res?.data;
};

const remove = async (apiKeyId) => {
    const res = await api.delete('/api/api-keys/delete', { data: { api_key_id: apiKeyId } });
    return res?.data;
};

const apiKeysService = { create, list, rotate, remove };
export default apiKeysService;
